import BaseService from "../base";
import ChangeMainTaskStepService from "./changeMainTaskStepService";

class ChangeMainTaskService extends BaseService {
  getActiveShareTaskList = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getChangeMainTaskList", para, success, error);
  };

  getRowData = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getTaskRowInfo", para, success, error);
  };

  getAccountDDL = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getAccountDDL", para, success, error);
  };

  submitForApproval = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("changeMainTaskSubmitForApproval", para, success, error);
  };

  checkSubmit = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkChangeMainTaskSubmit", para, success, error);
  };

  getChangeMainTaskStepItem = (
    para: any,
    success: any,
    error: any,
    interfaceList: any,
    mergePayloadMap: any
  ) => {
    ChangeMainTaskStepService.getStepData(para, success, error, interfaceList, mergePayloadMap);
  };

  manageShareTaskTriggerAction = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("changeMainTaskTriggerAction", para, success, error);
  };

  checkApprove = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkChangeMainTaskApprove", para, success, error);
  };

  checkHasPendingSignOff = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkHasPendingSignOff", para, success, error);
  };

  getFlowStepData = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getFlowStepData", para, success, error);
  };
}

const changeMainTaskService = new ChangeMainTaskService();

export default changeMainTaskService;
